export const containsLowercaseCharacters = (value: string): boolean => {
  const re = /[a-z]/;
  return re.test(value);
};

export const containsNumbers = (value: string): boolean => {
  const re = /\d/;
  return re.test(value);
};

export const containsUppercaseCharacters = (value: string): boolean => {
  const re = /[A-Z]/;
  return re.test(value);
};

export const hasMinEightCharacters = (value: string): boolean => {
  const re = /^.{8,}$/;
  return re.test(value);
};

export const isValidPassword = (value: string): boolean => containsNumbers(value)
  && containsUppercaseCharacters(value)
  && containsLowercaseCharacters(value)
  && hasMinEightCharacters(value);

export function validateDigitMaxLength(val: string, length: number) {
  return new RegExp(`^[0-9]{${length}}$`).test(val);
}

export function validateDigitLength(val: string, min: number, max: number) {
  return new RegExp(`^[0-9]{${min},${max}}$`).test(val);
}
